import React, { useState, useEffect } from 'react'
import ReactTable from 'react-table'

import TransComponent from 'components/Trans'
import { useTranslation } from 'react-i18next'

export default function Table ({
  pageSize,
  data,
  columns,
  showPagination
}) {
  const { t } = useTranslation()
  const [currentPage, setCurrentPage] = useState(0)
  const [tempPageSize, setTempPageSize] = useState(pageSize)

  // Reset to first page when pageSize changes
  useEffect(() => {
    setCurrentPage(0)
  }, [pageSize])

  return (
    <>
      <ReactTable
        pageSize={ tempPageSize }
        page={ currentPage }
        onPageChange={ setCurrentPage }
        onPageSizeChange={ setTempPageSize }
        rowsText={ t( 'general.rows' ) }
        noDataText={ <TransComponent i18nKey="general.no_rows_found"/> }
        previousText={ <TransComponent i18nKey="general.previous"/> }
        nextText={ <TransComponent i18nKey="general.next"/> }
        pageText={ <TransComponent i18nKey="general.page"/>  }
        data={ data }
        columns={ columns }
        showPagination={ showPagination } /> 
    </>
  )
}
